import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { reduxForm, Field, SubmissionError } from "redux-form";
import api from "@/middlewares/api";
import { ROUTESLIST } from "@/static/urls";

// import WithAuthRedirect from "@/components/hoc/with-auth-redirect";
import AffiliateService from "@/services/affiliate.js";

// import BgImage from "@/assets/images/pages/signup_bg.png";
import FrontBanner from "@/assets/images/front-banner.svg";
import GoogleIcon from "@/assets/images/google-icon.png";
import AppleIcon from "@/assets/images/apple-icon.png";
import CheckboxField from "../../components/forms/checkbox-field";

import { withAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import FormField from "../../components/forms/form-field";
import PasswordField from "../../components/forms/password-field";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getToken } from "../../actions/auth";
// import { testimonialsData } from "../../utils/constants";
import OurClients from "../../components/our-clients";

import "./signup.scss";
// import { Form, Formik, ErrorMessage } from "formik";
import Testimonials from "../../components/testimonials";

const bgStyles = {
  background: "#000",
};

const validate = (values) => {
  const errors = {};

  // Email
  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = "Please enter a valid email address";
  }

  // Password — Auth0 default policy: min 8 chars, at least 1 lowercase, 1 uppercase, 1 number, 1 special
  if (!values.password) {
    errors.password = "Password is required";
  } else {
    if (values.password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    } else if (!/[a-z]/.test(values.password)) {
      errors.password = "Password must contain at least 1 lowercase letter";
    } else if (!/[A-Z]/.test(values.password)) {
      errors.password = "Password must contain at least 1 uppercase letter";
    } else if (!/[0-9]/.test(values.password)) {
      errors.password = "Password must contain at least 1 number";
    } else if (!/[\W_]/.test(values.password)) {
      errors.password = "Password must contain at least 1 special character";
    }
  }

  // Confirm password
  if (!values.password_confirmation) {
    errors.password_confirmation = "Please confirm your password";
  } else if (values.password && values.password_confirmation !== values.password) {
    errors.password_confirmation = "Passwords must match";
  }

  // Terms
  if (!values.acceptedTerms) {
    errors.acceptedTerms = "You must agree to the terms and conditions";
  }

  return errors;
};

class SignupPage extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      affiliateId: null,
      options: [],
      redirectToSubscription: false,
    };
  }

  async fetchAffiliateOptions() {
    try {
      const response = await api.get("approved-affiliate-list");
      const data = response.data;
      if (Array.isArray(data)) {
        this.setState({
          options: data.map((el) => ({ id: el.id, name: el.username })),
        });
      }
    } catch (err) {
      console.error("Error fetching affiliates:", err);
    }
  }

  async submitForm(data) {
    const { email, password } = data;

    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const client_id = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const client_secret = process.env.REACT_APP_AUTH0_CLIENT_SECRET;

    try {
      // Step 1: Signup the user
      const signupResponse = await fetch(
        `https://${domain}/dbconnections/signup`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            client_id: client_id,
            email,
            password,
            connection: "Username-Password-Authentication",
            grant_type: "password",
          }),
        }
      );

      const signupData = await signupResponse.json();

      if (!signupResponse.ok) {
        const code = signupData.code || signupData.error;
        const description = signupData.description || signupData.error_description || "";

        if (code === "invalid_signup" || description.includes("already exists")) {
          throw new SubmissionError({
            email: "An account with this email already exists. Please log in instead.",
          });
        } else if (code === "invalid_password" || signupData.name === "PasswordStrengthError") {
          const policy = signupData.policy || description;
          throw new SubmissionError({
            password: policy || "Password does not meet the security requirements.",
          });
        } else if (description.includes("blocked")) {
          throw new Error("Too many signup attempts. Please try again later.");
        } else {
          throw new Error(description || signupData.message || "Signup failed. Please try again.");
        }
      }

      // Step 2: Get an access token after signup
      const loginResponse = await fetch(`https://${domain}/oauth/token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          client_id: client_id,
          client_secret: client_secret,
          grant_type: "password",
          username: email,
          password: password,
          realm: "Username-Password-Authentication",
          audience: `https://${domain}/api/v2/`,
          scope: "openid profile email",
        }),
      });

      const loginData = await loginResponse.json();

      if (!loginResponse.ok) {
        throw new Error(loginData.error || "Login failed");
      } else {
        console.log(loginData, "loginData");
        console.log(signupData, "signupData");
        this.setState({ redirectToSubscription: true });
        // this.props?.getToken(loginData?.access_token);
        localStorage.setItem("isIdentityLogin", true);
        localStorage.setItem("token", loginData?.access_token);
        localStorage.setItem("access_token", loginData?.access_token)
        // localStorage.setItem("useData", JSON.stringify(user));
        // localStorage.setItem("userInfo", JSON.stringify(user));
        localStorage.setItem("isIdentityLogin", "true");
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("isAuthenticated", true);
        toast.success("Signup and login successful!");
        this.props.history.push("/userdashboard/mysamples");
      }
    } catch (err) {
      if (err instanceof SubmissionError) {
        throw err;
      }
      toast.error("Error: " + err.message);
    }
  }

  loginWithGoogle = async () => {
    try {
      await this.props.auth0?.loginWithRedirect({
        authorizationParams: {
          connection: "google-oauth2",
          screen_hint: "signup",
        },
      });
      window.dispatchEvent(new Event("storage"));
    } catch (error) {
      console.error("Google Login Error:", error);
    }
  };

  loginWithApple = async () => {
    try {
      await this.props.auth0?.loginWithRedirect({
        authorizationParams: { connection: "apple", screen_hint: "signup" },
      });
    } catch (error) {
      console.error("Apple Login Error:", error);
    }
  };

  componentDidMount = async () => {
    const id = AffiliateService.getId("id");
    if (id) this.setState({ affiliateId: id });
  };
  componentWillUnmount() {
    this.setState({
      redirectToSubscription: false,
    });
  }

  render() {
    const { pristine, submitting, handleSubmit } = this.props;
    const { redirectToSubscription } = this.state;
    // const token = localStorage.getItem("token");
    if (redirectToSubscription)
      return <Redirect to={`${ROUTESLIST.CLEAR_SAMPLE}`} />;
    // return <Redirect to={`clear-sample`} />;
    // if (redirectToSubscription)
    //   return <Redirect to={ROUTESLIST.SUBSCRIPTIONS} />;

    return (
      <main className="page">
        <section
          // className="form-section form-section--radial"
          style={bgStyles}
        >
          <div className="content">
            <div className="front-banner">
              <img
                src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg"
                alt="front-banner"
                className="banner-image"
              />
              <h3 className="front-header">Create an account to save<br></br>thousands of dollars with a membership!</h3>
              <p className="front-paragraph">
                You make the music, and leave the clearance problems to us!<br></br>
                Built for independent music professionals who want faster, smarter, and more affordable clearances.
              </p>
              {/* <button className="btn-width">Join now</button> */}
            </div>
          </div>
          <div className="content">
            <div className="review-video">
              <div className="review-video__inner">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/5hqbvLuArkE?si=YPReqYT4sSSYDPHY"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <div className="content-tight">
            <div className="outer-signup">
              <h3 className="outer-header">Sign up with</h3>
              <button className="outer-button" onClick={this.loginWithGoogle}>
                <img src={GoogleIcon} alt="Google" />
                <span>Sign up with Google</span>
              </button>
              <button className="outer-button" onClick={this.loginWithApple}>
                <img src={AppleIcon} alt="Apple" />
                <span>Sign up with Apple</span>
              </button>
            </div>
            <div className="divider">
              <span>OR</span>
            </div>
            <form
              onSubmit={handleSubmit(this.submitForm)}
              className="signup-form"
              noValidate
            >
              <Field
                name="email"
                component={FormField}
                type="email"
                label="Email"
                className="signup-field"
                // placeholder="Type Your Email"
              />
              <Field
                name="password"
                component={PasswordField}
                label="Password"
                className="signup-field"
                // placeholder="Type Your Password"
              />
              <Field
                name="password_confirmation"
                component={PasswordField}
                label="Confirm Password"
                className="signup-field"
                // placeholder="Confirm Your Password"
              />
              <Field
                name="acceptedTerms"
                component={CheckboxField}
                label="I agree with terms and conditions"
                className="signup-field"
              />
              <div className="form-submit-row">
                <button
                  className="btn btn-primary btn-fw"
                  disabled={pristine || submitting}
                  type="submit"
                  /* onClick={() => {
                    this.setState({
                      redirectToSubscription: true
                    })
                  }} */
                >
                  Create Account
                </button>
              </div>
              <div className="form-field center">
                Allready have an account?{" "}
                <Link to="/login" className="link">
                  Log in
                </Link>
              </div>
            </form>
            {/* <Formik
              initialValues={{ email: "", password: "", confirmPassword: "", terms: false }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                console.log("Form Submitted", values);
              }}
            >
              {({ errors, touched }) => (
                <Form className="signup-form">
                  <label>Email</label>
                  <Field
                    type="email"
                    name="email"
                    className={`input-field ${errors.email && touched.email ? "error" : ""}`}
                  />
                  <ErrorMessage name="email" component="div" className="error-message" />

                  <label>Password</label>
                  <div className="password-container">
                    <Field
                      type={showPassword ? "text" : "password"}
                      type="text"
                      name="password"
                      className={`input-field ${errors.password && touched.password ? "error" : ""}`}
                    />
                    <span onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <EyeOff /> : <Eye />}
                    </span>
                  </div>
                  <ErrorMessage name="password" component="div" className="error-message" />

                  <label>Confirm Password</label>
                  <div className="password-container">
                    <Field
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      className={`input-field ${errors.confirmPassword && touched.confirmPassword ? "error" : ""
                        }`}
                    />
                    <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      {showConfirmPassword ? <EyeOff /> : <Eye />}
                    </span>
                  </div>
                  <ErrorMessage name="confirmPassword" component="div" className="error-message" />

                  <div className="checkbox-container">
                    <Field type="checkbox" name="terms" id="terms" />
                    <label htmlFor="terms">I agree with terms and conditions</label>
                  </div>
                  <ErrorMessage name="terms" component="div" className="error-message" />

                  <button type="submit" className="submit-button">Create Account</button>
                </Form>
              )}
            </Formik> */}
          </div>
          <Testimonials />
          <OurClients />
        </section>
      </main>
    );
  }
}

// Map Redux state to props
const mapStateToProps = (state) => ({
  auth: state.auth,
});

// Map Redux actions to props
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToken,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: "SignupForm", validate })(withAuth0(SignupPage)));
